import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/objective/importer/objectiveImporterActions';

export default importerReducers(actions);
